import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { loadIndividualConsultations } from './actions';
import { getChild } from '../reducer';
import List from './List';
import Grid from './Grid';
import ui from '../../common/services/ui';

class IndividualConsultations extends Component {
	constructor(props) {
		super(props);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		this.props.loadIndividualConsultations(this.props.pagination);
	}

	handleListEvent(listPagination) {
		this.props.loadIndividualConsultations(listPagination);
	}

	render() {
		const { data, pagination, hasChildren, enableUserTimeZone, t } = this.props;

		return (<div>
			{ui.isMobileView ? <Grid data={data} onFetchData={this.handleListEvent} enableUserTimeZone={enableUserTimeZone} {...pagination} /> :
				<List data={data} onFetchData={this.handleListEvent} enableUserTimeZone={enableUserTimeZone} {...pagination} />}
			{data.length > 0 && <div className='info-message' dangerouslySetInnerHTML={{ __html: t('FO_Booking_IndividualConsultation_InfoMessage') }} />}
		</div>);
	}
}

const mapStateToProps = state => {
	const { parent, entities: { individualConsultations, centers }, pagination, configuration: { franchisor } } = state;

	const consultationsPagination = pagination.individualConsultations.all || { ids: [], pageNumber: 1, pageSize: 10 };

	const visibleConsultations = consultationsPagination.ids.map(id => {
		const consultation = individualConsultations[id];

		const child = getChild(parent, consultation.childId);
		const center = centers[consultation.centerId];

		return {
			...consultation,
			child,
			center
		};
	});

	return {
		data: visibleConsultations,
		pagination: consultationsPagination,
		hasChildren: parent.children.length > 0,
		enableUserTimeZone: franchisor && franchisor.enableUserTimeZone
	};
};

export default connect(mapStateToProps, {
	loadIndividualConsultations
})(withTranslation()(IndividualConsultations));